module.exports = __webpack_public_path__ + "static/media/feature.15ec2ddd.jpg";